import type { RouteObject } from 'react-router-dom';

import { Scopes } from '../../../api/types';
import { RouteGuard } from '../../../components/RouteGuard';
import { SectorTemplateGalleryPage } from './pages/SectorTemplateGalleryPage';
import { SectorTemplatePreviewPage } from './pages/SectorTemplatePreviewPage';

/**
 * Routes contributed by the sector-template gallery feature (Phase 8 Wave 8.E).
 * Mounted before the `/document-types/:slug` catch-all so the literal `/templates`
 * segment wins routing.
 */
export const sectorTemplateRoutes: RouteObject[] = [
  {
    path: 'document-types/templates',
    element: (
      <RouteGuard scope={Scopes.SchemasRead}>
        <SectorTemplateGalleryPage />
      </RouteGuard>
    ),
  },
  {
    path: 'document-types/templates/:templateId',
    element: (
      <RouteGuard scope={Scopes.SchemasWrite}>
        <SectorTemplatePreviewPage />
      </RouteGuard>
    ),
  },
];
